import { createBrowserHistory, createMemoryHistory } from 'history';

export const createHistory = (url = '/') =>
  __SERVER__ ? createMemoryHistory({ initialEntries: [url] }) : createBrowserHistory();
